module.exports = function() {
  return new Worker(__webpack_public_path__ + "graph.worker.6e5cc066.worker.js");
};